import {NgModule, LOCALE_ID, ModuleWithProviders} from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { CookieModule } from 'ngx-cookie';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { NgJhipsterModule, translatePartialLoader, missingTranslationHandler, JhiConfigService } from 'ng-jhipster';
import locale from '@angular/common/locales/en';
import {AccountService} from './account.service';
import {EventService} from './event.service';





  // static forRoot(): ModuleWithProviders {
  //   return {
  //     ngModule: FrontEndCoreModule,
  //     providers: [AccountService]
  //   };
  // }
@NgModule({})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [AccountService, EventService]
    };
  }
}



